import { render } from "./AccordionTransition.vue?vue&type=template&id=e11a8920"
import script from "./AccordionTransition.vue?vue&type=script&lang=js"
export * from "./AccordionTransition.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__